import { ISurveyDescription, IRaiting } from '@valhalla/data/entities';
import { Observable } from 'rxjs';

export abstract class SurveyDataHttpService {
	abstract getResult(userId: number): Observable<ISurveyDescription>;
	abstract sendRating(taskId: number, points: Array<IRaiting>): Observable<any>;
}
